import botBuilderCanvasDark from "@circle-assets/images/bot-builder-canvas-dark.png";
import botBuilderCanvas from "@circle-assets/images/bot-builder-canvas.png";
import type { AgentProp } from "@circle-react/components/SettingsApp/CommunityBot/agentsQueries";
import { useThemeContext } from "@circle-react/providers";
import { Loader } from "@circle-react-uikit/Loader";
import { CollapsedSidebar } from "../CollapsedSidebar";
import { Header } from "../Header";
import { BotWorkflowsTable } from "./BotWorkflowsTable";
import { EmptyState } from "./EmptyState";
import { useBotHasWorkflows } from "./hooks/useBotWorkflowsQuery";

export const AutomationsPage = ({ agent }: { agent: AgentProp }) => {
  const { isDarkAppearance } = useThemeContext();
  const { hasWorkflows, isLoading } = useBotHasWorkflows(agent.id);

  const onClose = () => {
    window.location.href = "/settings/ai-agents/agents";
  };

  const handleNewWorkflow = () => {
    window.location.href = "/settings/workflows/new";
  };

  if (!agent) return null;

  if (isLoading) {
    return (
      <div className="flex flex-col">
        <Header agent={agent} onClose={onClose} />
        <div className="flex h-full">
          <CollapsedSidebar />
          <div className="flex-1">
            <Loader center />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <Header agent={agent} onClose={onClose} />
      {hasWorkflows ? (
        <div className="flex h-full">
          <CollapsedSidebar />
          <div className="flex-1">
            <BotWorkflowsTable
              agent={agent}
              onNewWorkflow={handleNewWorkflow}
            />
          </div>
        </div>
      ) : (
        <div
          className="flex h-full"
          style={{
            backgroundImage: `url("${isDarkAppearance ? botBuilderCanvasDark : botBuilderCanvas}")`,
          }}
        >
          <CollapsedSidebar />
          <div className="flex-1">
            <EmptyState agent={agent} onPrimaryClick={handleNewWorkflow} />
          </div>
        </div>
      )}
    </div>
  );
};
